import React from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { ShowConcierge } from "../../API/Concierge";
import NewLoader from "../../new-components/title/Loader/NewLoader";
import Title from "../../new-components/title/Title";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";
import NewFooter from "../../NewFooter";
import { trackCategoryViewed, trackMenuItemViewed } from "../../utils/mixpanel";

import SaOtherImage from "../../assets/new_imgs/Other.png";
import luggagePickupImage from "../../assets/new_imgs/luggagepickup.png";
import luggageDropImage from "../../assets/new_imgs/Luggagedrop.png";
import WakeupCallImage from "../../assets/new_imgs/Wakeup.png";

const saConciergeImagesBySlug = {
  "luggage-pickup": luggagePickupImage,
  "luggage-drop": luggageDropImage,
  "wake-up-call": WakeupCallImage,

  other: SaOtherImage,
};

function ConceirgeServices() {
  const navigate = useNavigate();
  const location = useLocation();
  const countryCode = localStorage.getItem("countryCode");
  const isSaudi = countryCode?.toUpperCase() === "SA";
  const rawPath = location.pathname;

  const room_uuid = rawPath.split("/")[1];

  const lang = localStorage.getItem("lang");
  let concierges;
  let text;
  const params = useParams();
  const { data, isLoading } = ShowConcierge(room_uuid, lang);

  if (!isLoading) {
    if (data.data.status === false) {
      navigate(`/${room_uuid}/qr-scan`);
    } else {
      let newData = data.data.data;
      concierges = newData?.concierge;
      text = newData?.title;
    }
  }
  return (
    <div className="food pb-5">
      <Title title={text} />
      <div className="box_food">
        {isLoading ? (
          <NewLoader />
        ) : (
          concierges?.map((x, idx) => {
            const saImage =
              isSaudi && saConciergeImagesBySlug[(x?.slug || "").toLowerCase()];
            return (
              <Link
                key={idx}
                to={`/${params.room_uuid}/${x.slug}?theme=true`}
                onClick={() =>
                  trackMenuItemViewed({
                    item_id: x.id,
                    item_name: x.name || "",
                    category_name: "Concierge",
                  })
                }
              >
                {saImage ? (
                  <img src={saImage} alt="" className="booking_img" />
                ) : (
                  <img src={x?.image} alt="" className="booking_img" />
                )}
                <img src={Overllay} alt="" className="overlay" />
                <div className="text_food">
                  <h5 className="">{x.name}</h5>
                </div>{" "}
              </Link>
            );
          })
        )}
      </div>
      <NewFooter />
    </div>
  );
}
export default ConceirgeServices;
